/*
defines the general data structure for nodes
including updating based on API response
*/

import {getNewDataFromAPI} from 'utilities/utilities';
import apis from 'utilities/api';

/*
~~ How to make a new kind of node ~~ see node.md
*/

/**
 * Represents a node
 */
export default class Node {
    /**
     * makes a new node given an id and a function to call when the API responds
     * @param {number} id id of the node to be created
     * @param {Function} [updateCallback] (optional) external function to be called when this node's api responds
     */
    constructor(id, updateCallback = function() {}) {
        this.id = Math.floor(Math.random() * 100000).toString();
        this.updateCallback = updateCallback;
        this.apiSource = {};
        this.apiResponse = {};
    }


    /**
     * given information about an API, makes an ajax call using the given url, given request object, and headers
     */
    getNewNodeData() {
        return getNewDataFromAPI(this.apiSource,
                                    this.apiResponse,
                                    this.updateCallback);
    }

    getAPISource(style, source, query){
        // if (query){
        //     return apis[style][source].call(apis[style], query);
        // } else {
        //     return apis[style][source].call(apis[style]);
        // }
        return apis[style][source].call(apis[style], query);
    }

    /**
     * gets the title of the node
     */
    get title() {
        return this.apiSource.title(this.apiResponse);
    }

    /**
     * gets all the data about the node
     */
    get metadata() {
        return this.apiSource.metadata(this.apiResponse);
    }

    /**
     * checks if the API returned anything
     */
    isEmpty() {
        return _.isEmpty(this.apiResponse) || this.apiSource.isEmpty(this.apiResponse);
    }

    /**
     * sets the given function as the one to call when (new) data comes in, for example from the API
     * @param {Function} updateCallback
     */
    setUpdateCallback(updateCallback) {
        this.updateCallback = updateCallback;
        if (!_.isEmpty(this.apiResponse)) {
            this.updateCallback();
        } else {
            console.log('getting node data');
            this.getNewNodeData();
        }
    }
}